import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import { Box, IconButton, TablePagination, useMediaQuery, useTheme } from '@mui/material'
import { PaginatorRes } from '../../../../pages/Pedidos/context/pedidos.context'
import { INITIAL_ROWS_PER_PAGE, rowsPerPageOptions } from '../../../../pages/Products/components/TableDataPagination'

interface TablePaginationActionsProps {
  count: number
  page: number
  rowsPerPage: number
  onPageChange: (event: React.MouseEvent<HTMLButtonElement>, newPage: number) => void
}

export const TablePaginationActions = (props: TablePaginationActionsProps & { hasNextPage: boolean }) => {
  const { page, rowsPerPage, count, onPageChange, hasNextPage } = props

  const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, 0)
  }

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1)
  }

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1)
  }

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    const lastPage = Math.ceil(count / rowsPerPage) - 1
    onPageChange(event, Math.max(0, lastPage))
  }

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={!page || page < 1} aria-label="first page">
        <FirstPageIcon />
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={!page || page < 1} aria-label="previous page">
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton onClick={handleNextButtonClick} disabled={!hasNextPage} aria-label="next page">
        <KeyboardArrowRight />
      </IconButton>
      <IconButton onClick={handleLastPageButtonClick} disabled={!hasNextPage} aria-label="next page">
        <LastPageIcon />
      </IconButton>
    </Box>
  )
}

interface TablaServerPaginationProps {
  component?: React.ElementType<any>
  label: string
  paginator: PaginatorRes
}

const TablaServerPagination = ({ component = 'div', label, paginator }: TablaServerPaginationProps) => {
  const { pageNumber, pageSize, hasNextPage, totalRecord, handleChangePage, handleChangeRowsPerPage } = paginator
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const currentPage = Math.max(0, (pageNumber || 1) - 1)
  return (
    <TablePagination
      width={'auto'}
      component={component}
      rowsPerPageOptions={rowsPerPageOptions}
      count={totalRecord}
      rowsPerPage={pageSize || INITIAL_ROWS_PER_PAGE}
      page={currentPage}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      ActionsComponent={(props) => <TablePaginationActions {...props} hasNextPage={hasNextPage} />}
      labelRowsPerPage={label}
      labelDisplayedRows={({ from, to, count }) => {
        if (!count || count === 0) {
          return '0-0 de 0'
        }
        return `${from}-${to} de ${count}`
      }}
      sx={{
        '& div': {
          display: 'flex'
        },
        '& p': {
          alignSelf: 'end'
        },
        ...(isMobile && { display: 'flex', alignSelf: 'start' })
      }}
    />
  )
}

export default TablaServerPagination
